var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 5C12.375 4.1712 12.0458 3.37634 11.4597 2.79029C10.8737 2.20424 10.0788 1.875 9.25 1.875C8.4212 1.875 7.62634 2.20424 7.04029 2.79029C6.45424 3.37634 6.125 4.1712 6.125 5C6.125 5.8288 6.45424 6.62366 7.04029 7.20971C7.62634 7.79576 8.4212 8.125 9.25 8.125C10.0788 8.125 10.8737 7.79576 11.4597 7.20971C12.0458 6.62366 12.375 5.8288 12.375 5ZM4.25 5C4.25 3.67392 4.77678 2.40215 5.71447 1.46447C6.65215 0.526784 7.92392 0 9.25 0C10.5761 0 11.8479 0.526784 12.7855 1.46447C13.7232 2.40215 14.25 3.67392 14.25 5C14.25 6.32608 13.7232 7.59785 12.7855 8.53553C11.8479 9.47322 10.5761 10 9.25 10C7.92392 10 6.65215 9.47322 5.71447 8.53553C4.77678 7.59785 4.25 6.32608 4.25 5ZM2.42578 18.125H16.0742C15.7266 15.6523 13.6016 13.75 11.0352 13.75H7.46484C4.89844 13.75 2.77344 15.6523 2.42578 18.125ZM0.5 18.8398C0.5 14.9922 3.61719 11.875 7.46484 11.875H11.0352C14.8828 11.875 18 14.9922 18 18.8398C18 19.4805 17.4805 20 16.8398 20H1.66016C1.01953 20 0.5 19.4805 0.5 18.8398Z",
    fill: "#4B5563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.e1ade3130ba0e41df43c80d7747b74f7.svg";
export { ForwardRef as ReactComponent };